import { Cartesian3, ScreenSpaceEventType, createGuid, } from "cesium";
import { CesiumPointSelectorType, } from "../../cesium-utils/point-selector/point-selector";
import { getDefaultRoadSettings } from "../../settings/earthbrain-site-settings";
import { RoadStructure } from "../../site/road-structure";
import { Road } from "../../site/road/earthbrain-road";
import { ConstructionState } from "../../site/trench/earthbrain-trench";
import { PositionReference, checkPositionWrtToTileset, } from "../../utilities/local-utilities";
import { AddPointCommand } from "./road-commands";
export class RoadConstructionHandler {
    _callback;
    _roadUnderConstruction;
    _viewer;
    _preview;
    _handler;
    _commandManager;
    _cesiumPicker;
    _finishRoadConstructionHandler;
    _cesiumPointSelector;
    // point list
    _cesiumViewer;
    _site;
    _associatePointCloudId;
    _associateDrawing2dImageId;
    get road() {
        return this._roadUnderConstruction;
    }
    constructor(args, cesiumViewer) {
        this._site = args.site;
        this._viewer = args.viewer;
        this._preview = args.preview;
        this._handler = args.handler;
        this._commandManager = args.commandManger;
        this._cesiumPicker = args.cesiumPicker;
        this._cesiumPointSelector =
            args.cesiumPointSelectorFactory.getPointSelector(CesiumPointSelectorType.PriorityBased);
        this._cesiumViewer = cesiumViewer;
    }
    _mosueMoveDebounce = undefined;
    _debounceHandlerForSphereMovement(movement) {
        if (this._mosueMoveDebounce) {
            clearTimeout(this._mosueMoveDebounce);
            this._mosueMoveDebounce = undefined;
        }
        this._mosueMoveDebounce = setTimeout(() => {
            this._functionForPreviewSphereMovement(this._roadUnderConstruction, movement);
            this._mosueMoveDebounce = undefined;
        }, 100);
    }
    async _functionForPreviewSphereMovement(road, movement) {
        // const cartesian = this._cesiumPicker.getPointOnMousePos(
        // 	movement.endPosition,
        // );
        const cartesian = await this._cesiumPointSelector.getPointOnMousePos(movement.endPosition);
        if (cartesian) {
            this._preview.setSpherePosition(cartesian);
            // add point to the road id the ditance between it and last point is less than 10 KM
            if (this.lastAddedPoint_wgs84 &&
                this.getDistanceFromLastAddedPointInKM(cartesian) < 10) {
                this._preview.setLineVisibility(true);
                this._preview.setLinePosition([
                    this.lastAddedPoint_wgs84.wgs84PointWithAdjustedHeight,
                    cartesian,
                ]);
            }
            else {
                this._preview.setLinePosition([]);
            }
            this._viewer.scene.requestRender();
        }
    }
    async addPointOnLeftClick({ position: mousePos, }) {
        const previewPos = await this._cesiumPointSelector.getPointOnMousePos(mousePos);
        if (previewPos) {
            const arr = await this._site.convertPointsToLocalSpace([previewPos]);
            const localPos = arr[0];
            const positionRef = checkPositionWrtToTileset(localPos, this._roadUnderConstruction.associatedTerrain);
            const pickedInfo = positionRef !== PositionReference.OUTSIDE
                ? this._cesiumPicker.getPickablePickedInfo(mousePos)
                : undefined;
            // Do not process further
            if (positionRef === PositionReference.OUTSIDE) {
                this.raiseEventInvalidCtrlPtForRoad(this._roadUnderConstruction.id);
                return;
            }
            if (!localPos) {
                console.error("Cound not find the Point");
                return;
            }
            if (this.getDistanceFromLastAddedPointInKM(previewPos) < 10) {
                await this._commandManager.action(new AddPointCommand(this._roadUnderConstruction, {
                    position: previewPos,
                    info: pickedInfo,
                    localPosition: localPos,
                }, () => {
                    this._preview.setLinePosition([]);
                }), this._cesiumViewer);
                this._preview.setLineVisibility(true);
                this._preview.setLinePosition([]);
            }
            this._callback.onProgress &&
                this._callback.onProgress(this._roadUnderConstruction.id, 0);
        }
    }
    //   private _onMouseRightDown() {
    //     this._isMouseRightClicked = true;
    //     this._handler.setInputAction(this._onMouseRightUp.bind(this), Cesium.ScreenSpaceEventType.RIGHT_UP);
    //   }
    //   private _onMouseRightUp() {
    //     this._isMouseRightClicked = false;
    //     this._handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_UP);
    //   }
    start(callback, associatedRubbingDestination, associatedTerrain) {
        this._callback = callback;
        this._roadUnderConstruction = new Road(this._viewer, createGuid(), getDefaultRoadSettings(), associatedRubbingDestination, associatedTerrain);
        this._roadUnderConstruction.constructionState =
            ConstructionState.UNDER_CONSTRUCTION;
        this._preview.setSphereVisibility(true);
        this._handler.setInputAction(this._debounceHandlerForSphereMovement.bind(this), ScreenSpaceEventType.MOUSE_MOVE);
        this._handler.setInputAction(this.addPointOnLeftClick.bind(this), ScreenSpaceEventType.LEFT_CLICK);
        this._finishRoadConstructionHandler =
            this._finishRoadConstruction.bind(this);
        document.addEventListener("keydown", this._finishRoadConstructionHandler);
    }
    startWithClickCount(callback, rubbingDestination, associatedTerrain, clickLimit, associatePointCloudId, associateDrawing2dImageId) {
        let clickCount = 0;
        this._associatePointCloudId = associatePointCloudId;
        this._associateDrawing2dImageId = associateDrawing2dImageId;
        const wrappedCallback = {
            onFinish: (roadId) => {
                clickCount = 0;
                callback?.onFinish?.(roadId);
            },
            onProgress: (roadId, progress) => {
                clickCount++;
                callback?.onProgress?.(roadId, progress);
                if (clickCount >= clickLimit) {
                    this.finish();
                }
            },
            onStart: callback?.onStart,
            onCancel: () => {
                clickCount = 0;
                callback?.onCancel?.();
            },
        };
        this.start(wrappedCallback, rubbingDestination, associatedTerrain);
    }
    _finishRoadConstruction(event) {
        switch (event.key) {
            case "Esc":
            case "Escape":
                this.cancel();
                break;
            case "Enter":
                this.finish();
                break;
            default:
        }
    }
    finish() {
        this._commandManager.clear();
        if (this._roadUnderConstruction.controlPointLength > 1) {
            this._roadUnderConstruction.constructionState = ConstructionState.READY;
            this._site.addRoad(this._roadUnderConstruction);
            const roadStructure = new RoadStructure(this._roadUnderConstruction);
            this._site.structureManager.addStructure(this._roadUnderConstruction.id, roadStructure);
            const connectionNodes = roadStructure.getConnectionNodes();
            for (const node of connectionNodes) {
                this._site.structureManager.addConnection(node);
            }
            this._preview.setLineVisibility(false);
            this._preview.setSphereVisibility(false);
            // this._viewer.scene.requestRender();
            this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
            this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
            this._finishRoadConstructionHandler &&
                document.removeEventListener("keydown", this._finishRoadConstructionHandler);
            this._callback.onFinish &&
                this._callback.onFinish(this._roadUnderConstruction.id);
        }
        else {
            console.warn("Road needs atleast 2 points.");
            this.cancel();
        }
    }
    cancel() {
        if (this._roadUnderConstruction) {
            this._roadUnderConstruction.dispose();
        }
        this._roadUnderConstruction = undefined;
        this._preview.setSphereVisibility(false);
        this._preview.setLineVisibility(false);
        // this._viewer.scene.requestRender();
        this._handler.removeInputAction(ScreenSpaceEventType.LEFT_CLICK);
        this._handler.removeInputAction(ScreenSpaceEventType.MOUSE_MOVE);
        this._finishRoadConstructionHandler &&
            document.removeEventListener("keydown", this._finishRoadConstructionHandler);
        this._callback?.onCancel && this._callback.onCancel();
        this._viewer.scene.requestRender();
    }
    raiseEventInvalidCtrlPtForRoad(roadID) {
        const event = new CustomEvent("invalidControlPointForRoad", {
            detail: { roadID, type: 0 },
        });
        window.dispatchEvent(event);
        this._callback.onError && this._callback.onError();
    }
    get lastAddedPoint_wgs84() {
        return this._roadUnderConstruction.cesiumRenderableAlignment.ipLinePoints[this._roadUnderConstruction.cesiumRenderableAlignment.ipLinePoints
            .length - 1];
    }
    getDistanceFromLastAddedPointInKM(point) {
        if (!this.lastAddedPoint_wgs84) {
            return 0;
        }
        const distance = Cartesian3.distance(point, this.lastAddedPoint_wgs84.wgs84Point);
        return distance * 0.001; // convert to km
    }
}
//# sourceMappingURL=road-construction-handler.js.map